/**
 * Type-safe access to Vite env. All VITE_* vars are exposed to the bundle.
 */
export const env = {
  MOCK_AUTH:
    (import.meta.env.VITE_MOCK_AUTH ?? 'true').toLowerCase() === 'true',
  ENTRA_TENANT_ID: import.meta.env.VITE_ENTRA_TENANT_ID ?? '',
  ENTRA_CLIENT_ID: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
  API_AUDIENCE:
    import.meta.env.VITE_API_AUDIENCE ?? 'api://vari-crew-scheduler',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN ?? '',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? '',
} as const;
